import React from 'react'
import '../../App.css'
import './Membership.css'
import { Link } from "react-router-dom";
import membershipImage from '../../assets/img/Membership-image.png'
import { Fade } from 'react-reveal';
export const Membership = () => {
  return (
    <div className='row'>
      <Fade left>

      <div className='col-xl-4 membership-img-container'>
        <img src={membershipImage}/>
      </div>
      </Fade>

      <Fade right>

    <section className="membership col-xl-8">
      <div className="container membership-heading">

        <p className='mt-5 h3 text-center'>Why Become a Member of Lacuna Venture <br/> Startup Academy?</p>
        <nav className='m-auto w-75'>

        </nav>
      </div>
      <div className="m-auto w-75 container">

          <ul>
            <b>
            <li>Get connected with fellow entrepreneurs, startup founders, and investors.</li>
            <li>Get mentorship sessions for your personal and professional careers.</li>
            <li>Grow your business network.</li>
            <li>Market research and development strategies</li>
            <li>Launch your startup</li>
            <li>Learn more about Startups & Entrepreneurship.</li>
            <li>Get unlimited start-up resources.</li>
            <li>Build valuable insights for your ideas.</li>
            </b>
          </ul>
        
        <ul className="list-unstyled d-flex justify-content-center mt-5">
          
          <li><Link to="/appMember" className='nav-link-mobile2 text-center'>Begin your Application</Link></li>
        
        </ul>

        {/* <div className="step-process">
           <h3 className='my-3'>Here is a brief look at the application process:</h3>
          <ul >
            <li>
              <a href="">
                <strong><h5>Application Review:</h5></strong>
                <p> Once received, your application will be reviewed by your local or bridge chapter to ensure that all criteria is met.</p>
              </a>
            </li>
            <li>
              <a href="">
                <strong><h5>Chapter Communication:</h5></strong>
                <p> Upon receipt of your application, your local chapter will schedule an interview with you to further explore your interest in EO.</p>
              </a>
            </li>
            <li>
              <a href="">
                <strong><h5> EONetwork:</h5></strong>
                <p> When your application is accepted, you will gain access to Forum, chapter and Global events, as well as a wide variety of other member benefits. Discover the benefits available to you.

</p>
              </a>
            </li>
            <li>
              <a href="">
                <strong><h5>Orientation and Training:</h5></strong>
                <p>  Within the first three months of membership, you will partake in an EO orientation from a member of the EO staff. You will also go through Forum training and be placed in a Forum.</p>
              </a>
            </li>
            <li>
              <a href="">
                <strong><h5> Member Dues:</h5></strong>
                <p> Member fees comprise both Global and chapter dues. Global dues are currently Rs24700 (plus a one-time Rs.90000 initiation fee) and are prorated based on the fiscal month you join. Chapter dues differ depending on your chapter’s policies.</p>
              </a>
            </li>
            <li>
              <a href="">
                <strong><h5>Application Review:</h5></strong>
                <p> Once received, your application will be reviewed by your local or bridge chapter to ensure that all criteria is met.</p>
              </a>
            </li>
       
          </ul>
        </div> */}
      </div>
    </section>
      </Fade>
    </div>
  )
}
